import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { List, ListItem, ListItemText } from '@material-ui/core';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import AccountCircleIcon from '@material-ui/icons/Face';
import UsersIcon from '@material-ui/icons/Group';
import CategoriesIcon from '@material-ui/icons/ClearAll';
import { Link } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export default function ListItemsLeft() {
  const classes = useStyles();
  const [
    open, setOpen, openC, setOpenC
  ] = React.useState(false);

  const handleClickProduct = () => {
    setOpen(!open);
  };
  const handleClickClient= () => {
    setOpen(!open);
  };

  return (
    <>
    <List>
      <ListItem button component={Link} to="/profile">
        <ListItemIcon>
          <AccountCircleIcon/>
        </ListItemIcon>
        <ListItemText primary="Perfil" />
      </ListItem>

      <ListItem button component={Link} to="/categories" >
        <ListItemIcon>
          <CategoriesIcon/>
        </ListItemIcon>
        <ListItemText primary="Categorías" />
      </ListItem>

      <ListItem button component={Link} to="/content" >
        <ListItemIcon>
          <UsersIcon/>
        </ListItemIcon>
        <ListItemText primary="Usuarios" />
      </ListItem>

    </List>
    </>
  );
}